import { NAME } from './constants';
import { router } from './router';

export const InventuraPolozky = {
	name: NAME,
	router,
};
